import { useState } from 'react';
import { Link } from 'react-router-dom';
import { courseList, courseStats } from '@/mocks/courses';
import SEOHead from '@/components/feature/SEOHead';

type Course = typeof courseList[0];

const EDUCATION_JSONLD = [
  {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: '富缘佳旺情感教育学院',
    description: '专业情感指导与婚姻教育课程，所有课程仅需¥1象征性费用，已有10万+学员通过课程找到更幸福的感情。',
    url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/education`,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '情感教育课程 - 富缘佳旺婚恋教育平台',
    description: '专业情感指导与婚姻教育课程，所有课程仅需¥1象征性费用，已有10万+学员通过课程找到更幸福的感情。',
    url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/education`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: import.meta.env.VITE_SITE_URL || 'https://example.com' },
        { '@type': 'ListItem', position: 2, name: '情感教育', item: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/education` },
      ],
    },
  },
];

function EnrollModal({ course, onClose }: { course: Course; onClose: () => void }) {
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleEnroll = () => {
    setLoading(true);
    setTimeout(() => { setLoading(false); setDone(true); }, 1200);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
      <div className="bg-white rounded-3xl w-full max-w-sm shadow-2xl overflow-hidden">
        <div className="bg-gradient-to-r from-rose-600 to-amber-500 px-6 py-5 relative">
          <button onClick={onClose} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/20 text-white hover:bg-white/30 cursor-pointer">
            <i className="ri-close-line"></i>
          </button>
          <h3 className="text-white font-bold text-base">{done ? '报名成功！' : '立即报名'}</h3>
          <p className="text-white/70 text-xs mt-0.5">{course.title}</p>
        </div>

        {done ? (
          <div className="px-6 py-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
              <i className="ri-checkbox-circle-line text-green-600 text-3xl"></i>
            </div>
            <h4 className="font-bold text-gray-800 text-lg mb-2">报名成功！</h4>
            <p className="text-sm text-gray-500 mb-1">您已成功报名《{course.title}》</p>
            <p className="text-xs text-gray-400 mb-6">课程将发送至您的邮箱，请注意查收</p>
            <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 mb-6">
              <p className="text-xs text-amber-700 flex items-start gap-2">
                <i className="ri-information-line mt-0.5 flex-shrink-0"></i>
                <span>仅需 <strong>¥1</strong> 象征性费用，是为了让您更珍惜这份用心准备的课程内容。感谢您的支持！</span>
              </p>
            </div>
            <button onClick={onClose} className="w-full py-3 bg-gray-800 text-white rounded-xl font-semibold text-sm cursor-pointer hover:bg-gray-700 transition-all whitespace-nowrap">
              开始学习
            </button>
          </div>
        ) : (
          <div className="px-6 py-6 space-y-4">
            <div className="flex gap-3 bg-gray-50 rounded-2xl p-3">
              <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0">
                <img src={course.image} alt={course.title} className="w-full h-full object-cover object-top" />
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800">{course.title}</p>
                <p className="text-xs text-gray-400 mt-0.5">{course.instructor} · {course.lessons}课时</p>
                <div className="flex items-center gap-1 mt-1">
                  <span className="text-rose-600 font-bold text-base">¥{course.price}</span>
                  <span className="text-xs text-gray-300 line-through ml-1">¥{course.originalPrice}</span>
                  <span className="text-xs bg-rose-100 text-rose-600 rounded-full px-2 py-0.5 ml-1 font-medium">象征性收费</span>
                </div>
              </div>
            </div>

            <div className="bg-rose-50 border border-rose-100 rounded-2xl p-4">
              <p className="text-xs text-rose-700 leading-relaxed">
                <i className="ri-heart-line mr-1"></i>
                <strong>为什么收¥1？</strong> 免费的东西往往不被珍惜。我们用心制作每一节课，希望您认真对待，让知识真正改变您的感情生活。
              </p>
            </div>

            <div className="space-y-2">
              {[
                { icon: 'ri-play-circle-line', text: `${course.lessons}节精品课时 · ${course.duration}` },
                { icon: 'ri-user-star-line', text: `${course.instructor} · ${course.instructorTitle}` },
                { icon: 'ri-group-line', text: `已有 ${course.students.toLocaleString()}+ 学员报名` },
                { icon: 'ri-infinity-line', text: '永久回看，随时学习' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2 text-xs text-gray-600">
                  <i className={`${item.icon} text-rose-500 flex-shrink-0`}></i>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>

            <button
              onClick={handleEnroll}
              disabled={loading}
              className="w-full py-3 bg-gradient-to-r from-rose-600 to-amber-500 text-white rounded-xl font-bold text-sm hover:opacity-90 transition-all cursor-pointer whitespace-nowrap disabled:opacity-60"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i> 处理中...
                </span>
              ) : `¥1 立即报名学习`}
            </button>
            <p className="text-center text-xs text-gray-400">安全支付 · 支持微信/支付宝/银行卡</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default function EducationPage() {
  const [activeTag, setActiveTag] = useState('全部');
  const [enrollCourse, setEnrollCourse] = useState<Course | null>(null);
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const allTags = ['全部', '婚前准备', '沟通技巧', '情商提升', '海外华人', '约会技巧', '家庭规划'];
  const filtered = activeTag === '全部' ? courseList : courseList.filter(c => c.tags.includes(activeTag));

  return (
    <div className="min-h-screen bg-gray-50 pb-16 md:pb-0">
      <SEOHead
        title="情感教育课程 - 富缘佳旺婚恋教育平台 仅需¥1 | FortuneMatch"
        description="富缘佳旺情感教育课程，专业婚前准备、沟通技巧、情商提升等课程，仅需¥1象征性费用。已有10万+学员通过课程找到更幸福的感情生活。"
        keywords="情感教育,婚恋课程,婚前准备,沟通技巧,富缘佳旺教育"
        canonical="/education"
        jsonLd={EDUCATION_JSONLD}
      />
      {/* Nav */}
      <nav className="bg-white border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16">
          <div className="flex items-center gap-4">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/b31ed3570265bb91107b593ba40da4ad.jpeg"
                alt="富缘佳旺"
                className="w-8 h-8 rounded-full object-cover"
              />
              <span className="text-sm font-bold text-red-700" style={{ fontFamily: "'Noto Serif SC', serif" }}>富缘佳旺</span>
            </Link>
            <span className="text-gray-300">|</span>
            <div className="flex items-center gap-1.5 text-gray-700">
              <i className="ri-book-open-line text-rose-500"></i>
              <span className="text-sm font-semibold">情感教育课程</span>
            </div>
          </div>
          <Link to="/auth" className="px-5 py-2 bg-rose-600 text-white rounded-full text-sm font-semibold hover:bg-rose-700 transition-all cursor-pointer whitespace-nowrap">
            <i className="ri-user-line mr-1"></i>登录 / 注册
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <div className="relative bg-gradient-to-br from-gray-900 via-rose-950 to-gray-900 py-16 md:py-24 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/37262cc615248c69aff45bd36055d28c.jpg"
          alt="education hero"
          className="absolute inset-0 w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/60 via-transparent to-gray-900/60"></div>
        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-5 py-2 mb-6">
            <i className="ri-book-open-line text-amber-400"></i>
            <span className="text-sm text-white/80">专业情感指导 · 婚姻教育课程</span>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Noto Serif SC', serif" }}>
            用知识，守护爱情
          </h1>
          <p className="text-white/60 text-sm md:text-base max-w-2xl mx-auto leading-relaxed mb-6">
            所有课程几乎免费，仅象征性收取 <strong className="text-amber-400">¥2</strong>，是为了让您更珍惜这份用心准备的内容。
            <br />真正的爱，从学习开始。
          </p>

          {/* Price Highlight */}
          <div className="inline-flex items-center gap-4 bg-white/10 border border-white/20 rounded-2xl px-6 py-4 mb-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-amber-400">¥1</div>
              <div className="text-xs text-white/60 mt-0.5">象征性费用</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-left">
              <p className="text-white text-sm font-semibold">为什么不完全免费？</p>
              <p className="text-white/60 text-xs mt-0.5 max-w-xs">免费的东西往往不被珍惜。¥1让您认真对待每一节课，让知识真正改变您的感情生活。</p>
            </div>
          </div>

          {/* Stats Row */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-10">
            {courseStats.map((s, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl font-bold text-white">{s.num}</div>
                <div className="text-xs text-white/50 mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        {/* Tag Filter */}
        <div className="flex flex-wrap gap-2 mb-8">
          {allTags.map((tag) => (
            <button
              key={tag}
              onClick={() => setActiveTag(tag)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${activeTag === tag ? 'bg-rose-600 text-white' : 'bg-white border border-gray-200 text-gray-600 hover:border-rose-300'}`}
            >
              {tag}
            </button>
          ))}
        </div>

        {/* Course Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((course) => (
            <div key={course.id} className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:-translate-y-1 transition-all duration-300 group">
              {/* Image */}
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {course.badge && (
                  <div className="absolute top-3 left-3 bg-rose-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                    {course.badge}
                  </div>
                )}
                <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-1">
                  <span className="text-rose-600 font-bold text-sm">¥{course.price}</span>
                  <span className="text-gray-300 text-xs line-through">¥{course.originalPrice}</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className={`w-7 h-7 flex items-center justify-center rounded-lg ${course.color} flex-shrink-0`}>
                    <i className={`${course.icon} text-sm`}></i>
                  </div>
                  <span className="text-xs text-gray-400">{course.titleEn}</span>
                </div>
                <h3 className="font-bold text-gray-800 text-base mb-1">{course.title}</h3>
                <p className="text-xs text-gray-500 leading-relaxed mb-3 line-clamp-2">{course.desc}</p>

                {/* Instructor */}
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-user-star-line text-amber-500 text-xs"></i>
                  <span className="text-xs text-gray-500">{course.instructor}</span>
                  <span className="text-xs text-gray-300">·</span>
                  <span className="text-xs text-gray-400 truncate">{course.instructorTitle.split('·')[0]}</span>
                </div>

                {/* Meta */}
                <div className="flex items-center gap-4 mb-3 text-xs text-gray-400">
                  <span><i className="ri-play-circle-line mr-1"></i>{course.lessons}课时</span>
                  <span><i className="ri-time-line mr-1"></i>{course.duration}</span>
                  <span><i className="ri-group-line mr-1"></i>{course.students.toLocaleString()}人</span>
                </div>

                {/* Rating */}
                <div className="flex items-center gap-1 mb-4">
                  {[1,2,3,4,5].map((s) => (
                    <i key={s} className={`ri-star-fill text-xs ${s <= Math.round(course.rating) ? 'text-amber-400' : 'text-gray-200'}`}></i>
                  ))}
                  <span className="text-xs text-gray-500 ml-1">{course.rating}</span>
                </div>

                {/* Tags */}
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {course.tags.map((tag) => (
                    <span key={tag} className="text-xs bg-gray-50 border border-gray-100 text-gray-500 rounded-full px-2.5 py-0.5">{tag}</span>
                  ))}
                </div>

                {/* CTA */}
                <div className="flex gap-2">
                  <button
                    onClick={() => setEnrollCourse(course)}
                    className="flex-1 py-2.5 bg-gradient-to-r from-rose-600 to-amber-500 text-white rounded-xl font-semibold text-sm hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
                  >
                    ¥1 立即报名
                  </button>
                  <button
                    onClick={() => setExpandedId(expandedId === course.id ? null : course.id)}
                    className="px-3 py-2.5 border border-gray-200 text-gray-500 rounded-xl text-sm hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className={`${expandedId === course.id ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
                  </button>
                </div>

                {/* Expanded Detail */}
                {expandedId === course.id && (
                  <div className="mt-3 pt-3 border-t border-gray-100 space-y-2">
                    <p className="text-xs text-gray-600 leading-relaxed">{course.desc}</p>
                    <p className="text-xs text-gray-500"><i className="ri-user-star-line mr-1 text-amber-500"></i>{course.instructorTitle}</p>
                    <div className="bg-amber-50 rounded-xl p-3">
                      <p className="text-xs text-amber-700">
                        <i className="ri-heart-line mr-1"></i>
                        仅需¥1，永久回看，随时随地学习，让爱更有智慧。
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 bg-gradient-to-r from-rose-600 to-amber-500 rounded-3xl p-8 md:p-12 text-center text-white">
          <h2 className="text-2xl md:text-3xl font-bold mb-3" style={{ fontFamily: "'Noto Serif SC', serif" }}>
            爱，需要学习
          </h2>
          <p className="text-white/70 text-sm mb-2 max-w-xl mx-auto">
            所有课程仅需 <strong className="text-amber-300">¥1</strong> 象征性费用，因为我们相信：真正用心的内容，值得被认真对待。
          </p>
          <p className="text-white/50 text-xs mb-8">已有 <strong className="text-white">10万+</strong> 学员通过我们的课程找到了更好的自己和更幸福的感情</p>
          <Link
            to="/auth"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white text-rose-600 rounded-full font-bold text-sm hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-user-add-line"></i>注册后免费浏览全部课程
          </Link>
        </div>
      </div>

      {enrollCourse && <EnrollModal course={enrollCourse} onClose={() => setEnrollCourse(null)} />}
    </div>
  );
}
